export default __webpack_public_path__ + "static/media/Major Rune Stone of the Red Wake.77aa214d.jpg";